import React,{ useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import useHandleGroupSearch from '../../../deviceManagement/useHandleGroupSearch';
import { getAllNodeValues } from '../../../../components/treeView/util';
import { ICountyDetails, IGroupAlerts, ISelectGroupState } from '../../../../common/types/alertsTypes';
import { ITreeNode } from '../../../../common/types/commonTypes';
import { selector as listAlertTypesApi } from './listAlertTypesSlice';
import {createDas} from "./createDasSlice";
import { getCookie, isSuccessResponse } from '../../../../common/utils'; 
import useNotification from '../../../../components/notification/useNotification';


export const useCreateDas = () => {
    const dispatch: any = useDispatch();
    const alertTypesResponse = useSelector(listAlertTypesApi);
    const { handleGroupInputChange, groupSearchQuery, nodesToDisplay } = useHandleGroupSearch({isEditable: false});

    const alertsOptions = alertTypesResponse?.alertTypes
    const countyOptions = alertTypesResponse?.countyDetails;
      
    const createSelectGroupState: ISelectGroupState = {
    groups: [],
    checked: [],
    selectAllChecked: false,
  };

    const [sendAutomatically, setSendAutomatically] = useState<boolean|null>(true);
    const [disableCountyValue, setDisableCountyValue] = useState<boolean|null>(null);
    const [selectedTemplate, setSelectedTemplate] = useState<number>(null);
    const [templateId, setTemplateId] = useState<number>(0);
    const [selectedAlertsOptions, setSelectedAlertsOptions] = useState<any[]>([]);
    const [selectedCountyOptions, setSelectedCountyOptions] = useState<any[]>([]);
    const [selectedTotalOptions, setSelectedTotalOptions] = useState<any[]>([]);
    const [placedHolderAlertsValues, setPlacedHolderValues] = useState<string>("Select Value");
    const [placedHolderGroupValues, setPlacedHolderGroupValues] = useState<string>("Select Value");
    const [placedHolderCountyValues, setPacedHolderCountyValues] = useState<string>("Select Value");
    const [selectGroupState, setSelectGroupState] = useState<ISelectGroupState>(createSelectGroupState);
    const [selectAllChecked, setSelectAllChecked] = useState<boolean>(selectGroupState.selectAllChecked);
    const [selectedGroups, setSelectedGroups] = useState<IGroupAlerts[]>(selectGroupState?.groups);
 
    const handleRadioChange = (value: boolean) => {setSendAutomatically(value);};
    
    const isTemplateDivSelected = (templateId: number) =>
    selectedTemplate === templateId;
    
    const handleTemplateClick = (templateId: number) => {
    const newSelectedTemplate =
    selectedTemplate === templateId ? null : templateId;
    setSelectedTemplate(newSelectedTemplate);
    setTemplateId(newSelectedTemplate);
  };

  const handleDataFromTreeView = (selectedGroup) => {
    const groups: IGroupAlerts[] = getAllValuesWithLabels(selectedGroup);
    setSelectedGroups(groups);
    const allNodeValues: string[] = getAllNodeValues(
      selectedGroup,
      selectGroupState.selectAllChecked
    );
    setSelectGroupState({
      ...selectGroupState,
      groups: groups,
      checked: allNodeValues,
    });
    setPlacedHolderGroupValues(groups.length>0 ? `(${groups.length}) Groups are Seleted`:"Select Value")
  };

  const getAllValuesWithLabels = (nodes: ITreeNode[] | IGroupAlerts[]) => {
    let result: IGroupAlerts[] = [];
    function traverse(node) {
      result.push({
        id: node.value || node.id,
        displayName: node.label || node.displayName,
      });
      if (selectGroupState?.selectAllChecked) {
        if (node.children && node.children.length > 0) {
          for (const child of node.children) {
            traverse(child);
          }
        }
      }
    }
    for (const node of nodes) {
      traverse(node);
    }
    return result;
  };

  const handleSelectAllChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const isChecked: boolean = event.target.checked;
    if (isChecked) {
      setSelectAllChecked(true);
      setSelectGroupState({
        ...selectGroupState,
        selectAllChecked: true,
      });
      
    } else {
      setSelectAllChecked(false);
      setSelectGroupState({
        ...selectGroupState,
        selectAllChecked: false,
      });
      
    }
  };

  const handleAlertsSelect = (selectedList: any, selectedItem: any) => {
    const placeHolderValue = selectedList.length > 0 ? (selectedList[0].name ==='Select All'? `(${alertsOptions.slice(0).length-1}) Alert Types Selected`: `(${selectedList.filter((item) => item.name !== 'Select All').length}) Alert Types Selected`) : "Select Status";

     if (selectedItem.name === 'Select All') {
      setPlacedHolderValues(`(${alertsOptions.filter((item) => item.name !== 'Select All').length}) Alert Types Selected`);
      if (selectedList.length === alertsOptions.length) {
        setSelectedAlertsOptions(alertsOptions.slice(0)); 
      } else {
        setSelectedTotalOptions(alertsOptions.slice(1));
        setSelectedAlertsOptions(alertsOptions.slice(0)); 
      }
    } else {
      setPlacedHolderValues(placeHolderValue);
      setSelectedTotalOptions(selectedList.filter((item) => item.name !== 'Select All'));
      setSelectedAlertsOptions(selectedList.filter((item) => item.name !== 'Select All'));
    }
  };

   const handleAlertsRemove = (selectedList: any, selectedItem: any) => {
    if (selectedItem.name === 'Select All') {
      setPlacedHolderValues("Select Status")
        setSelectedTotalOptions([]);
        setSelectedAlertsOptions([]);
    }
    else{
    let placeholder = selectedList.length > 0? `(${selectedList.length}) Alert Types Selected`:"Select Status";
    setSelectedTotalOptions(selectedList)
    setPlacedHolderValues(placeholder);
    }
    const check = selectedList.length>0 ? (selectedList[0].name === 'Select All'? true : false) : false;
    if(check){
      setSelectedAlertsOptions(selectedList.filter((item) => item.name !== 'Select All'));
      setSelectedTotalOptions(selectedList.filter((item) => item.name !== 'Select All'));
      setPlacedHolderValues(`(${selectedList.filter((item) => item.name !== 'Select All').length}) Alert Types Selected`);
    }
    
  };

   const handleCountySelect = (selectedItem: ICountyDetails, isChecked: boolean) => {
     if (isChecked) {
       setSelectedCountyOptions([selectedItem]);
       setPacedHolderCountyValues(`${selectedItem.name} ( ${selectedItem.state} )`);
     } else {
       setSelectedCountyOptions([]);
       setPacedHolderCountyValues("Select Value");
     }
   };

   const { showSuccessNotification, showWarningNotification } = useNotification();
const dispatchCreateDas = (
        action,
        payload,
      ) => {
        try {
          dispatch(action(payload)).then((response) => {
            if(isSuccessResponse(response.payload)){
              showSuccessNotification(response.payload.message);
            }
            else {
              showWarningNotification(response.payload.response.data.message);
            }
          });
        } catch (error) {
          console.error("Error:", error);
        }
      };


    const handleSubmit = ()=>{
      const orgId = getCookie('organizationId');
            const payload ={
          alertType:selectedTotalOptions,
          groups:selectedGroups,
          templateId,
          needsApproval:!sendAutomatically,
          county:selectedCountyOptions[0]?.name,
          state:selectedCountyOptions[0]?.state,
          orgId,
      }
      dispatchCreateDas(createDas,payload);
      setSendAutomatically(true);
      setDisableCountyValue(null);
      setSelectedTemplate(null); 
      setTemplateId(0);
      setSelectedAlertsOptions([]);
      setSelectedCountyOptions([]);
      setSelectedTotalOptions([]);
      setPlacedHolderValues("Select Value");
      setPlacedHolderGroupValues("Select Value");
      setPacedHolderCountyValues("Select Value");
    }

    return {
        handleRadioChange,
        sendAutomatically,
        isTemplateDivSelected,
        handleTemplateClick,
        handleSubmit,
        handleAlertsSelect,
        handleAlertsRemove,
        alertsOptions,
        selectedAlertsOptions,
        setSelectedAlertsOptions,
        handleGroupInputChange,
         groupSearchQuery, 
         nodesToDisplay,
         handleDataFromTreeView,
         selectAllChecked,
         selectGroupState,
         setSelectGroupState,
         handleSelectAllChange,
        placedHolderAlertsValues,
        selectedCountyOptions,
        handleCountySelect,
        countyOptions,
        disableCountyValue,
        placedHolderCountyValues,
        selectedTotalOptions,
        selectedGroups,
        templateId,
        placedHolderGroupValues,
    };
}